import Image from 'next/image';
import { useRef } from 'react';

import { Explore } from '@/icons/index';

import styles from './WhoWeAre.module.scss';

export const WhoWeAre = ({ data }) => {
  const scrollRef = useRef(null);

  const handleScroll = () => {
    if (scrollRef.current) {
      document.body.scrollTop = 800;
      document.documentElement.scrollTop = 800;
    }
  };

  const renderTitle = (item, index) => {
    return (
      <div key={index} className={styles.text_item}>
        {item}
      </div>
    );
  };
  return (
    <div
      className={styles.who_we_are}
      ref={scrollRef}
      itemScope
      itemType='http://schema.org/Property'
    >
      <div className={styles.content}>
        <div className={styles.decorated_title}>
          {data?.title?.map(renderTitle)}
        </div>
        <div className={styles.imageWrapper}>
          <Image
            src={data?.image}
            alt='banner image'
            width={1130}
            height={646}
          />
          <div className={styles.btn_box} onClick={() => handleScroll()}>
            <Explore />
            <p>{data?.button_text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;
